import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";

import { BaseFlex, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;
const { setFontVariant } = mixins;

export const Container = styled(BaseFlex)<{ isDisabled: boolean }>`
    gap: 4px;
    cursor: pointer;
    ${({ isDisabled }) =>
        isDisabled &&
        `
        opacity: 0.4;
        pointer-events: none;
            `}
`;

export const Wrapper = styled.div<{ isDisabled: boolean }>`
    ${({ isDisabled }) => isDisabled && `cursor: not-allowed;`}
`;

export const LabelContainer = styled(FlexColumn)`
    gap: 4px;
`;

export const TitleContainer = styled(BaseFlex)`
    gap: 6px;
`;

export const Title = styled.div`
    ${setFontVariant("body1", carbon[500])}
`;

export const Subtitle = styled.div`
    ${setFontVariant("body1", carbon[300])}
`;

export const Icon = styled(SWReactIcons)`
    svg {
        path {
            fill: ${carbon[500]};
        }
    }
`;
